(function () {
  function publishCartUpdate(cartData) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nz-card', cartData });
        return;
      }
    } catch(e) {}
    document.dispatchEvent(new CustomEvent('nz:cart:update', { detail: cartData }));
  }

  async function addToCart(variantId) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });
    if (!res.ok) throw new Error('add failed');
    // Dawn a veces necesita el estado del carrito completo
    const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const cartData = cartRes.ok ? await cartRes.json() : null;
    if (cartData) publishCartUpdate(cartData);
    return cartData;
  }

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.nz-add-btn');
    if (!btn) return;
    if (btn.classList.contains('nz-add-btn--soldout')) return;

    const vid = btn.getAttribute('data-variant-id');
    if (!vid) return;

    const label = btn.querySelector('.nz-add-btn__label');
    const oldText = label ? label.textContent : '';

    btn.classList.add('is-loading');
    if (label) label.textContent = 'Agregando...';

    try {
      await addToCart(vid);
      if (label) label.textContent = 'Agregado ✓';
      setTimeout(() => { if (label) label.textContent = oldText || 'Agregar al carrito'; }, 1200);
    } catch (err) {
      if (label) label.textContent = 'Error, intenta';
      setTimeout(() => { if (label) label.textContent = oldText || 'Agregar al carrito'; }, 1400);
    } finally {
      btn.classList.remove('is-loading');
    }
  }, { passive: true });
})();
